import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import Loading from "wrappers/Loading";
import { SimpleWrapper } from "components/InputsMex/containers";
import {
  DropDownDate,
  DropDownFilter,
  PrimeTextInput,
} from "components/InputsMex/inputs";
import { Modal } from "react-bootstrap";
import SimpleContainer from "components/InputsMex/containers/SimpleContainer";
import { urlGuardarAseguradoSKT } from "constants/urls";
import { ApiKeyFetch } from "api/fetchers/apiKey";
import moment from "moment";
import useCustomToast from "hooks/useCustomToasts";
const ModalAsegurado = ({
  baseClassName = "w-100 text-center text-md-left mt-3",
  titleEdit = "Editar Información",
  titleGuardar = "Agregar Asegurado",
  child = "",
  data = [],
  edit = false,
}) => {
  const methods = useForm({ mode: "onChange" });

  const [modalShow, setModalShow] = useState(false);

  const { handleSubmit } = methods;

  const { addWarningToast } = useCustomToast();

  useEffect(() => {
    if (edit) {
      methods.reset(data.datos);
    }
  }, []);

  const opciones = [
    {
      label: "MASCULINO",
      value: {
        label: "MASCULINO",
        value: "M",
      },
    },
    {
      label: "FEMENINO",
      value: {
        label: "FEMENINO",
        value: "F",
      },
    },
  ];
  const edadAsegurado = {
    edadMaxima: 18,
    edadMinima: 6,
  };
  //console.log("PRINT...", data);

  const guardarAsegurado = async (formData) => {
    //setLoading(true);
    try {
      let body = {
        idPoliza: data.poliza,
        idAsegurado: data.id,
        datosAsegurado: formData,
        guardarDatos: false,
      };

      const response = await ApiKeyFetch.instance().post(
        urlGuardarAseguradoSKT,
        body
      );
      console.log("RES:::", response);
      if (response.transaccion) {
        window.location.reload();
      } else {
        setModalShow(false);
        addWarningToast(response.data?.mgsError);
      }
    } catch {}
  };

  const onGuardar = async () => {
    const data = methods.getValues();
    const formData = { ...data };

    await guardarAsegurado(formData);
  };
  const renderModal = () => {
    if (edit) {
      setTimeout(() => {
        setModalShow(true);
      }, 100);
    } else {
      setModalShow(true);
    }
  };

  return (
    <Loading loading={false}>
      <React.Fragment>
        <div className={`${baseClassName}`}>
          <p
            className="disclaimer-form-datos font-futura-medium cpointer text-mex"
            style={{ fontSize: "20px" }}
            onClick={() => {
              renderModal();
            }}
          >
            {edit && (
              <div className="ml-4" style={{ color: "#4568DB" }}>
                <span>
                  <i class="pi pi-pencil pr-2 res-text-value"></i>
                </span>
                {titleEdit}
              </div>
            )}
            {!edit && <i class="pi pi-plus res-text-value icon-crear"></i>}
          </p>
        </div>

        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onGuardar)}>
                <div className="container">
                  <div className="row mt-4">
                    <div className="col-md-12">
                      <h2 className=" mb-4">
                        {edit === true ? titleEdit : titleGuardar} {child}
                      </h2>

                      <h3 className="text-mex">
                        Por favor llena el siguiente formulario.
                      </h3>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12 ">
                      <SimpleWrapper
                        label="Nombre(s)"
                        name="nombres"
                        extrasClasses="margin-0"
                      >
                        <PrimeTextInput
                          name="nombres"
                          rules={{ required: "Este campo es obligatorio" }}
                        />
                      </SimpleWrapper>
                    </div>

                    <div className="col-md-6">
                      <SimpleWrapper
                        label="Apellido paterno"
                        name="apellidoPaterno"
                        extrasClasses="margin-0"
                      >
                        <PrimeTextInput
                          name="apellidoPaterno"
                          rules={{ required: "Este campo es obligatorio" }}
                        />
                      </SimpleWrapper>
                    </div>
                    <div className="col-md-6">
                      <SimpleWrapper
                        label="Apellido materno"
                        name="apellidoMaterno"
                        extrasClasses="margin-0"
                      >
                        <PrimeTextInput
                          name="apellidoMaterno"
                          rules={{ required: "Este campo es obligatorio" }}
                        />
                      </SimpleWrapper>
                    </div>
                    <div className="col-md-6">
                      <SimpleWrapper
                        label="Fecha de nacimiento"
                        name="fechaNacimiento"
                        extrasClasses="margin-0"
                      >
                        <DropDownDate
                          name="fechaNacimiento"
                          rules={{
                            required: "Este campo es obligatorio",
                            validate: (value) => {
                              const valueMoment = moment(value, "yyy-MM-DD");
                              const fechaMinima = moment().subtract(
                                edadAsegurado.edadMinima,
                                "months"
                              );
                              const fechaMaxima = moment().subtract(
                                edadAsegurado.edadMaxima,
                                "years"
                              );
                              if (valueMoment.isBefore(fechaMaxima)) {
                                return (
                                  "La edad máxima es de " +
                                  edadAsegurado.edadMaxima +
                                  " años cumplidos"
                                );
                              }
                              if (valueMoment.isAfter(fechaMinima)) {
                                return (
                                  "La edad mínima es de " +
                                  edadAsegurado.edadMinima +
                                  " meses"
                                );
                              }
                              return true;
                            },
                          }}
                          {...{
                            maxDate: moment()
                              .subtract(edadAsegurado.edadMaxima - 18, "years")
                              .toDate(),
                            minDate: moment()
                              .subtract(edadAsegurado.edadMaxima, "years")
                              .toDate(),
                          }}
                        />
                      </SimpleWrapper>
                    </div>
                    <div className="col-md-6 mt-4">
                      <SimpleContainer label="Sexo" name="sexo">
                        <DropDownFilter
                          name="sexo"
                          optionLabel={opciones}
                          optionValue="value"
                          onChangeFn={async () => {}}
                          rules={{
                            required: "Este campo es obligatorio",
                          }}
                          options={opciones}
                          helpText={"Seleccione"}
                        />
                      </SimpleContainer>
                    </div>

                    <div className="col-md-8 offset-md-2 text-center">
                      <button
                        id="btn-ingresar"
                        className="container-buttons btn-block btn btn-primary btn-mis-datos text-uppercase ml-auto"
                        type="submit"
                      >
                        Continuar
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </FormProvider>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    </Loading>
  );
};

export default ModalAsegurado;
